module.exports = __webpack_public_path__ + "img/HydroNext_120X35.e70aea82.png";